<template>
    <div id="app" class="min-h-screen bg-white dark:bg-neutral-900">
        <!-- Layout condicional baseado na rota -->
        <template v-if="isAuthRoute">
            <router-view />
        </template>
        <template v-else>
            <AppLayout>
                <router-view />
            </AppLayout>
        </template>

        <!-- Toast Container -->
        <ToastContainer />

        <!-- Global Confirm Modal -->
        <ConfirmModal
            :visible="confirmState.isVisible.value"
            :title="confirmState.options.value.title"
            :message="confirmState.options.value.message"
            :type="confirmState.options.value.type"
            :confirm-text="confirmState.options.value.confirmText"
            :cancel-text="confirmState.options.value.cancelText"
            @confirm="confirmState.handleConfirm"
            @cancel="confirmState.handleCancel"
        />

        <!-- Global Payment Modal -->
        <PaymentModal
            :visible="paymentState.isVisible"
            :amount="paymentState.amount"
            :paymentId="paymentState.paymentId"
            :brCode="paymentState.brCode"
            :expiresIn="paymentState.expiresIn"
            :brCodeBase64="paymentState.brCodeBase64"
        />
    </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useThemeStore } from "@/stores/theme";
import AppLayout from "@/components/layout/AppLayout.vue";
import paymentState from "@/composables/usePayment";
import ToastContainer from "@/components/ui/ToastContainer.vue";
import ConfirmModal from "@/components/ui/ConfirmModal.vue";
import PaymentModal from "@/components/ui/PaymentModal.vue";
import { confirmState } from "@/composables/useConfirm";

const route = useRoute();
const themeStore = useThemeStore();

// Rotas que não precisam do layout principal
const authRoutes = ["/", "/login", "/auth/callback", "/404"];
const isAuthRoute = computed(
    () => authRoutes.includes(route.path) || route.name === "NotFound",
);

onMounted(async () => {
    themeStore.initTheme();
});

</script>
